import React from 'react'

import Base from '../Base'

const Remove = props => (
  <Base {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M13,7H11v4H7v2h4v4h2V13h4V11H13Z"
      transform="translate(12 -4.971) rotate(45)"
    />
  </Base>
)

export default Remove
